<template>
  <div v-if="!loadData" class="flex items-center justify-center q-py-lg">
    <q-spinner-gears size="40px" color="primary"></q-spinner-gears>
  </div>
  <div
    v-else-if="loadData && !Object.values(registrationData).length"
    class="flex full-width column items-center q-py-lg"
    style="padding: 30px 0"
  >
    <q-icon name="hide_source" class="q-mb-sm" size="40px" color="primary"></q-icon>
    <span class="block" style="font-size: 16px">No data</span>
  </div>
  <div v-else class="q-pt-md">
    <AlibabaEnvironments :registrationData="registrationData" :registrationId="registrationId">
      <span class="label-block">Environments</span>
    </AlibabaEnvironments>
  </div>

  <AccessProductsTable :accessProducts="accessProducts" :loadAccessProducts="loadAccessProducts"></AccessProductsTable>
  <VirtualApisTable :virtualApis="virtualApis" :loadAccessProducts="loadAccessProducts"></VirtualApisTable>
  <span class="label-block q-mt-md" v-if="Object.values(infraService.links).length">Links:</span>
  <div class="links" v-if="Object.values(infraService.links).length">
    <Links :infraService="infraService" />
  </div>
</template>

<script>
import AccessProductsTable from '@/pages/digitalService/components/AccessProductsTable.vue';
import Links from './Links.vue';
import AlibabaEnvironments from '@/pages/registrations/components/registration-alibaba/AlibabaEnvironments.vue';
import { getRegistration } from '@/pages/registrations/api/api';
import VirtualApisTable from '@/pages/digitalService/components/VirtualApisTable.vue';

export default {
  name: 'AlibabaWidget',
  components: {
    AccessProductsTable,
    Links,
    AlibabaEnvironments,
    VirtualApisTable,
  },
  props: {
    infraService: { type: Object },
    accessProducts: { type: Object },
    virtualApis: { type: Array },
    loadAccessProducts: { type: Boolean, default: () => false },
    registrationId: { type: String },
  },
  data() {
    return {
      registrationData: {},
      loadData: false,
    };
  },
  async mounted() {
    try {
      const data = await getRegistration(this.registrationId, false, false);
      this.registrationData.digitalServiceApm = data.digitalService.apmId;
      this.registrationData.infrastructureServiceApm = data.infraService.apmId;
    } catch (error) {
      this.$notify('negative', 'Error', error.message);
    } finally {
      this.loadData = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.label-block {
  font-size: 14px;
  font-weight: bold;
}
</style>
